import Vue from 'vue';
import vuetify from '@/plugins/vuetify';
import App from './App.vue';
import api from './api';
import router from './router';
import store from './store';
import isEmail from './plugins/isEmail';

Vue.config.productionTip = false;

// $isEmail plugin
Vue.use(isEmail);

Vue.use({
  install(Vue) {
    Vue.prototype.$api = api;
  },
});

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount(`#app`);
